import { render, staticRenderFns } from "./CustomAmount.vue?vue&type=template&id=205a3ff6&scoped=true&"
import script from "./CustomAmount.vue?vue&type=script&lang=js&"
export * from "./CustomAmount.vue?vue&type=script&lang=js&"
import style0 from "./CustomAmount.vue?vue&type=style&index=0&id=205a3ff6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205a3ff6",
  null
  
)

export default component.exports